// extracted by mini-css-extract-plugin
export default {"mainWrap":"PrivacyPolicyPage_mainWrap__qHMWK cobe-globals_mainWrap__qu6Pq","container":"PrivacyPolicyPage_container__BhUaX","pageTitle":"PrivacyPolicyPage_pageTitle__2bc-C"};